import imgEC from 'assets/logos/environment-canada.png';
import imgABO from 'assets/logos/ArtsBuildOntario.png';
import imgCMHA from 'assets/logos/CMHA.png';
import imgKA from 'assets/logos/KidsAbility.png';
import imgTPS from 'assets/logos/TorontoPolice.png';
import imgSHFV from 'assets/logos/sh_logo_full_vertical.png';
import imgTwitter from 'assets/logos/twitter.svg';
import imgIG from 'assets/logos/instagram.svg';
import imgFB from 'assets/logos/facebook.svg';
import imgHC from 'assets/logos/canada_healthcare.jpg';

// Impact Space Icons
import iconAccessibility from 'assets/icons/Accessibility_white.png';
import iconCommunity from 'assets/icons/BuildingCommunitySpaces_white.png';
import iconSafety from 'assets/icons/PublicSafety_white.png';
import iconMentalHealth from 'assets/icons/MentalHealth_white.png';
import iconSustainability from 'assets/icons/Sustainability_white.svg';
import iconHealthcare from 'assets/icons/Healthcare_white.svg';

const siteConfig = {
	logos: {
		shLogoFullVertical: imgSHFV,
		twitter: imgTwitter,
		instagram: imgIG,
		facebook: imgFB,
	},
	impactSpaces: [
		{
			id: 'publicSafety',
			title: 'Public Safety',
			description: "The safety of our residents is vital to maintaining our valued community and overall country. Our community residents should feel and be safe from a range of risks such as natural disasters and such crimes. The Toronto Police Service is dedicated to delivering police services in partnership with communities to keep Toronto the best and safest place to be. Help the TPS ideate ways to maintain community safety!",
			color: '#2399E2',
			logo: imgTPS,
			icon: iconSafety,
			promptSets: [
				{
					title: 'Toronto Police Service',
					prompts: [
						"In a crisis, resulting in mass casualties, victims, and/or missing persons, how might we reunite the affected with their friends and family quickly and reliably?",
						"How can we analyze large collections of event reports to discover significant trends and provide investigative leads to Detectives?"
					]
				},
				{
					title: 'Additional Resources',
					resources: [
						{
							url: 'https://drive.google.com/file/d/1VQwsM8ThosLoxXGKH16dMKofXXxt2wxQ/view?usp=sharing',
							text: 'Problem Brief',

						}
					]
				},
			]
		},
		{
			id: 'sustainability',
			numCols: 1,
			title: 'Sustainability',
			description: 'Consumers often state that if they had more information at the point of purchase, they would more often purchase sustainable products. However, brands/stores struggle to provide this information to consumers. Additionally, in order to meet our sustainability targets, industry will need to reduce the environmental impact of the chemicals used in manufacturing processes. However, industry often struggles to choose the greenest chemicals and products to put on the market.',
			color: '#3C56A5',
			logo: imgEC,
			icon: iconMentalHealth,
			promptSets: [
				{
					title: 'Environment Canada',
					prompts: [
						'In order to meet our sustainability targets, industry will need to reduce the environmental impact of the chemicals used in manufacturing processes. However, industry often struggles to choose the greenest chemicals and products to put on the market. How might we improve their ability to make choices based on sustainability?',
						'Canadians often struggle to adopt behaviours that reduce their environmental footprint. How might we create new products/services that improve behaviour change to results in improved sustainability? A question related to this: What barriers does business/Canadians face that keeps them from taking pollution prevention actions?',
					]

				},
			]
		},
		{
			id: 'healthcare',
			title: 'Healthcare',
			description: '',
			color: '#6035A5',
			logo: null,
			icon: iconHealthcare,
			promptSets: [
				{
					title: 'Multiple Sclerosis Society of Canada',
					prompts: [
						'The Ontario Disability Support Program (ODSP) provides essential financial support to individuals with multiple sclerosis (MS), many of whom cannot participate in the workforce because of their illness. Despite being essential to most MS patients, the application process is so cumbersome and complicated that only 25% of patients obtain ODSP. How might we improve the ability of patients with MS to complete ODSP applications and improve the financial wellbeing?',
						'The impacts of multiple sclerosis (MS) go beyond the person diagnosed with the disease. Those who care for people with MS report higher than normal strain on items such as emotional adjustments, personal planning, and sleep. The situation seems to increase in severity as the severity of the disease increases. How might we reduce caregiver strain as a means of improving the quality of care for people with MS, and their caregivers?',
						'MS symptoms interfere with nutrition, sleep, emotional wellbeing, cognitive performance, swallowing, and mobility. A high disability level may impinge on adequate nourishment, impairing meal preparation, and eating. How might we improve nutrition, exercise, and/or emotional wellbeing in MS patients as a way of improving coping with symptoms and/or managing the progression of the disease?'
					]
				},
				{
					title: 'Lupus Canada',
					prompts: [
						'Patients with Lupus often need to change career trajectories to more part-time, precarious employment, or leave the workforce entirely because of the disease. How might we improve the participation of individuals with lupus in the workforce?',
						'The needs of patients with Lupus are exacerbated by lack of employment health insurance benefits and/or poor provincial health funding. This causes additional out-of-pocket expenses, particularly for pharmaceuticals and complementary care. How might we create scalable and affordable health services for individuals with lupus?',
						'Many patients with Lupus do not disclose their diagnosis in the workplace because of poor public knowledge and understanding of the disease. This means that employers cannot attribute changes in work habits and productivity to a disability. How might we change the behaviours and attitudes in workplace settings to be more accepting of long term disabilities?',
						'The way that employers accommodated employees with Lupus varies greatly in form and success rate (ex: flexible tasks, hours, and working location). How might we create more effective and scalable workplace accommodations for people living with long term disabilities?'
					]
				},
				{
					title: 'Waterloo Wellington Local Health Integration Network',
					prompts: [
						'The Local Health Integration Network, which manages over $2 billion dollars in health care funds for the Waterloo/Wellington region, is working with campuses in the region to improve communication with acute care facilities. The issue is that when a student is admitted to the ER for mental health reasons, there is no way to communicate care plans or other information to the network of organizations involved in the student\'s continued care. How might we create a coordinated communication platform to make sure that all the organizations involved in a student\'s care plan are properly informed? Cambridge Memorial is open to funding a solution to this problem.'
					]
				},
			]
		},
		{
			id: 'accessibility',
			title: 'Accessibility',
			description: "Mobility access with design of products, devices, services, or environments creates a safe and inclusive space for individuals with special needs. KidsAbility values inclusion, collaboration and is committed to providing a barrier-free environment for all individuals; making all things accessible, inclusive as well as respecting the independence of people with disabilities.",
			color: '#A81D8A',
			logo: imgKA,
			icon: iconAccessibility,
			promptSets: [
				{
					title: 'KidsAbility',
					prompts: [
						"We require a system that allows KidsAbility to track and monitor when staff are in a clients’ home, the location and that they are safe and secure. This system needs to be easy to use, if possible, connected to current software (i.e. Outlook Calendars?) and enable us to quickly know that staff are safe and if there’s a problem, to be able to quickly react.",
						"Our goal is to enable a child/youth the ability to engage in spontaneous, self-initiated play, exploration, social and recreational engagement on their own or with others. There are a variety of challenges that restrict clients, caregiver/friend/others’ abilities to play, explore and to interact with each other and their surroundings. These challenges exist for clients that use augmentative communication devices as well as clients who don’t need devices to communicate. This can be about technology and about other equipment.",
						"There is a significant amount of technology that exists but which is not accessible for clients with special needs. Adaptations are required in order for the technology to be effective utilized. What adaptations are possible and what is sustainable?"
					]
				},
				{
					title: 'General',
					prompts: [
						"How can public transportation be transformed to be inclusive and accessible-friendly for all?",
						"Our informational generation enables us to seize technological opportunities, however they are limited in access. How can we make websites and apps accessible-friendly for all?"
					]
				},
			]
		},
		{
			id: 'communitySpaces',
			title: 'Building Community Spaces',
			description: "At ArtsBuild Ontario, they value our close-knit community and the many foundations that help build our values and community relationships, especially showcasing the Arts our city has to offer. They are a non-profit arts service organization dedicated to realizing long-term solutions for building, managing and financing the sustainable arts facilities needed in Ontario communities.",
			color: '#2399E2',
			logo: imgABO,
			icon: iconCommunity,
			promptSets: [
				{
					title: 'ArtsBuild Ontario',
					prompts: [
						"ABO is looking to engage the local community with 44 Gaukel. This includes animating the space, showcasing artists at the O-Gallery and connecting with the public. How can we leverage technology to engage our community and tenants with this space?"
					]
				},
				{
					title: 'General',
					prompts: [
						"How can we encourage participation in our community?",
						"How can me foster inclusivity within our community?",
					]

				},
			]
		},
		{
			id: 'mentalHealth',
			title: 'Mental Health',
			description: "No matter who it is, where they are and what condition they may be in, everyone you meet  is fighting a battle you know nothing about. The Canadian Mental Health Association is the champion for mental health. They facilitate access to resources people require to maintain and improve mental health and community integration, build resilience, and support recovery from mental illness. What can you do to emphasize the importance of mental health and help individuals acquire the help they need?",
			color: '#3C56A5',
			logo: imgCMHA,
			icon: iconMentalHealth,
			promptSets: [
				{
					title: 'Canadian Mental Health Association',
					prompts: [
						"How can we encourage such individuals to reach out addictions and mental health systems to get the help they need?",
						"How do we know if they are taking the medication as prescribed or if there are side effects with the medication? How might that be impacting their mental health and overall wellness?",
					]
				},
				{
					title: 'General',
					prompts: [
						"How can we stop suicides from spreading?",
						"How can we eliminate long wait times for suicide hotlines?",
					]
				},
			]
		},
	]
};

export default siteConfig;
